import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody } from '@strava/ui/Modal';
import StravaAlert from 'components/StravaAlert';

const ModalWithAlerts = ({ alert, className, children, ...options }) => {
  return (
    <ModalBody className={className} {...options}>
      {alert && (
        <StravaAlert severity={alert.severity}>{alert.message}</StravaAlert>
      )}
      {children}
    </ModalBody>
  );
};

ModalWithAlerts.defaultProps = {
  className: null,
  alert: null
};

ModalWithAlerts.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  alert: PropTypes.shape({
    severity: PropTypes.string,
    message: PropTypes.string
  })
};

export default ModalWithAlerts;
